import { render, staticRenderFns } from "./FormCustomDate.vue?vue&type=template&id=f0ff5130"
import script from "./FormCustomDate.vue?vue&type=script&lang=js"
export * from "./FormCustomDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports